export type ImagePreset = "categoryTile" | "productCard" | "productDetail" | "thumb";

const defaultDeliveryOrigin = "https://images.truefitautomotivesolutions.co.ke";
const imageTransforms: Record<ImagePreset, string> = {
  categoryTile: "w=480,h=320,fit=cover,format=auto,quality=80",
  productCard: "w=640,h=460,fit=cover,format=auto,quality=80",
  productDetail: "w=1200,h=750,fit=cover,format=auto,quality=85",
  thumb: "w=160,h=160,fit=cover,format=auto,quality=75",
};

function deliveryOrigin() {
  const configuredOrigin: unknown = import.meta.env.VITE_IMAGE_DELIVERY_ORIGIN;

  if (typeof configuredOrigin !== "string" || !configuredOrigin.trim()) {
    return defaultDeliveryOrigin;
  }

  return configuredOrigin.replace(/\/+$/, "");
}

function encodedStorageKey(storageKey: string) {
  return storageKey
    .trim()
    .replace(/^\/+/, "")
    .split("/")
    .map((segment) => encodeURIComponent(segment))
    .join("/");
}

export function imageUrl(storageKey: string, preset: ImagePreset) {
  const normalizedStorageKey = encodedStorageKey(storageKey);

  if (!normalizedStorageKey) {
    return "";
  }

  return `${deliveryOrigin()}/cdn-cgi/image/${imageTransforms[preset]}/${normalizedStorageKey}`;
}
